<template>
	<v-radio-group
		ref="radioGroup"
		:value="value"
		:row="row"
		:hide-details="hideDetails"
		:dense="dense"
		v-bind="forwarded_attrs"
		v-on="$listeners"
	>
		<slot />
	</v-radio-group>
</template>

<script>
export default {
	name: 'KRadioGroup',
	inheritAttrs: false,
	model: {
		prop: 'value',
		event: 'change',
	},
	props: {
		value: [Boolean, String, Number],
		dense: Boolean,
		hideDetails: {
			type: [Boolean, String],
			default: 'auto'
		},
		row: Boolean,
	},
	computed: {
		forwarded_attrs() {
			const { 'aria-label': aria_label, 'aria-labelledby': aria_labelledby, ...rest } = this.$attrs
			return rest
		}
	},
	mounted() {
		this.sync_aria_group_label()
	},
	updated() {
		this.sync_aria_group_label()
	},
	methods: {
		sync_aria_group_label() {
			const radio_group = this.$refs.radioGroup?.$el?.querySelector('[role="radiogroup"]')
			if (!radio_group) return

			const aria_label = this.$attrs['aria-label']
			const aria_labelledby = this.$attrs['aria-labelledby']

			if (aria_label) {
				radio_group.setAttribute('aria-label', aria_label)
				radio_group.removeAttribute('aria-labelledby')
				return
			}

			if (aria_labelledby) {
				radio_group.setAttribute('aria-labelledby', aria_labelledby)
			}
		}
	}
};
</script>
